export const isVvsMinerMolePhase4BlindBoxReveal = Number(process.env.REACT_APP_VVS_GOTCHI_PHASE) > 3
export const isVvsMinerMolePhase3 = Number(process.env.REACT_APP_VVS_GOTCHI_PHASE) > 2
export const isVvsMinerMolePhase2 = Number(process.env.REACT_APP_VVS_GOTCHI_PHASE) > 1
export const isVvsMinerMolePhase1 = process.env.REACT_APP_VVS_GOTCHI_PHASE === '1'
